var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-group',[(_vm.isPath)?_c('v-path',{ref:"path",attrs:{"config":_vm.config}}):_vm._e(),(!_vm.isPath)?_c('v-line',{ref:"path",attrs:{"config":_vm.config,"points":_vm.points}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }